import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { ModelSchema } from "../types";

const c = initContract();
export const modelsContract = c.router({
  findMine: {
    path: "/models/mine",
    method: "GET",
    description: "Find mine model",
    responses: {
      200: ModelSchema.nullable(),
    },
  },
  findMineVersion: {
    path: "/models/mine/version",
    method: "GET",
    description: "Find the version of the model currently loaded for my company",
    responses: {
      200: z.object({
        version: z.string(),
      }),
    },
  },
  findAll: {
    path: "/models",
    method: "GET",
    description: "Find all models",
    responses: {
      200: ModelSchema.array(),
    },
  },
});
